function findClosestScrollingContainer(
  element: HTMLElement | null,
): HTMLElement | null {
  if (
    !element ||
    element === document.body ||
    element === document.scrollingElement
  ) {
    return null;
  }

  const style = getComputedStyle(element);
  return style.overflowY === 'visible'
    ? findClosestScrollingContainer(element.parentElement)
    : element;
}

export default findClosestScrollingContainer;
